import { tokenService } from 'services'
import useSWR, { SWRConfiguration } from 'swr'
import SWR_KEY from './constant'

export const useDepositTransaction = (configs?: SWRConfiguration) => {
	return useSWR(SWR_KEY.DEPOSIT_TRANSACTION, tokenService.getAloWallet, {
		revalidateOnFocus: false,
		...configs
	})
}